import { Component, Inject, SecurityContext, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { first, tap } from 'rxjs/operators';

export interface DialogData_AddAtt {
  current_lang: string;
}

@Component({
  selector: 'app-add-avatar',
  templateUrl: './add-avatar.component.html',
  styleUrls: ['./add-avatar.component.scss']
})
export class AddAvatarComponent implements OnInit {
  attPlaceholder: string = '';

  att_name = '';
  dataurl_var = '';
  file_type = '';
  wrong_type = true;
  not_empty_src = false;
  src = 'avatar';

  loading = false;

  constructor(public dialogRef: MatDialogRef<AddAvatarComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData_AddAtt,
              private sanitizer: DomSanitizer,
              private translate: TranslateService) {
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.changeLangFunction(true);
  }

  changeLangFunction(isInit: boolean = false): void {
    this.translate.get('attachment.placeholder').pipe(
      first(),
      tap((res: string) => {
        this.attPlaceholder = res;
        if (isInit) {
          this.att_name = this.attPlaceholder;
        }
      })
    ).subscribe();
  }

  noNewAttach() {
    return this.att_name === this.attPlaceholder;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  inputChange(fileInputEvent: any) {
    this.loading = true;
    const file: File = fileInputEvent.target.files[0];
    this.att_name = file.name;
    if (file.type.includes('image')) {
      this.wrong_type = false;
      this.file_type = 'picture';
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let url_supp = reader.result.toString();
        compressImage(url_supp, 300, 200).then((compressed: string) => {
          this.dataurl_var = this.sanitizer.sanitize(
            SecurityContext.URL,
            this.sanitizer.bypassSecurityTrustResourceUrl(compressed)
          );
          this.loading = false;
        });
      };
    } else {
      this.wrong_type = true;
      this.loading = false;
    }
  }

  newFile() {
    return {
        name: this.att_name,
        file_byte: this.dataurl_var,
        file_type: this.file_type,
        source: this.src,
        title_audio: false,
        avatar: true
    };
  }
}

function compressImage(src, newX, newY) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');
      elem.width = newX;
      elem.height = newY;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, newX, newY);
      const data = ctx.canvas.toDataURL();
      res(data);
    };
    img.onerror = error => rej(error);
  });
}
